import Model from './model';





export default Model.extend( {

    endpoint: 'statuses?apiVersion=2.0',
    
    defaults: {
        name: '',
        cluster: null,
        color: '',
        visible: true,
        'default': false,
        closed: false
    },

    customParser(attrs) {
        return attrs.order = +attrs.order, attrs;
    },
    
    computeds: {

        // make copy of "default" property
        // with "defaults" name: Epoxy cannot
        // deal with property named "default"
        defaults: {
            set(value) {
                return { 'default': value };
            },
            
            get() {
                return this.get( 'default' );
            }
        }

    }

} );


// WEBPACK FOOTER //
// ./src/js/model/status.js